export const situationsThree = [
  {
    id: 1,
    text: "Most of his friends and college mates were donating blood during the wartime. He...",
    response:
      "He donated blood, appreciates friend's efforts as well and motivated other for donating.",
  },
  {
    id: 2,
    text: "Your girlfriend wants to go to a movie, you would...",
    response: "Make a surprise movie plan and have fun. ",
  },
  {
    id: 3,
    text: "A topless lady meets you on a beach, you would...",
    response: "Greet her and enjoy the beach.",
  },
  {
    id: 4,
    text: "You are the commander of NCC camp, on reaching there on a cold night you notice there are no blanket and other materials, you...",
    response:
      "Inquired the person in charge, took action against them and sent few cadets to base to bring necessary items.",
  },
  {
    id: 5,
    text: "At SSB you are the president, JCO and candidates have a fight in camp, you...",
    response: "Disqualified the candidates and set up inquiry for JCO.",
  },
  {
    id: 6,
    text: "You are going to play an international cricket match representing India as Captain. Your ankle gets sprained. You...",
    response:
      "Took rest and sent a substitute to play and cheered for the team.",
  },
  {
    id: 7,
    text: "His friends spend a lot of money in college but his father does not give him any pocket money. He...",
    response:
      "Understood the financial condition of the family and focused on his studies.",
  },
  {
    id: 8,
    text: "In a birthday party, your friend hits you and you know that he is drunk. You...",
    response: "Took it lightly and dropped him home safely.",
  },
  {
    id: 9,
    text: "What would you keep in mind choosing your career...",
    response:
      " Job Satisfaction, diverse experience, personal development, and stability",
  },
  {
    id: 10,
    text: "You like the person who is...",
    response: "Self-motivated, disciplined, calm and problem-solving.",
  },
  {
    id: 11,
    text: "When you are late for office, and your boss asks for an explanation. You...",
    response: "I apologized, told truth and assured not being late in future.",
  },
  {
    id: 12,
    text: "While traveling in a Bus you see a pickpocket picking a pocket of a person who is standing ahead of you. And Pickpocket is one of your friends. You...",
    response: "I caught him red-handed, warned him and informed his family.",
  },
  {
    id: 13,
    text: "A shopkeeper charges more money for a product than the actual MRP. What would you do...",
    response: "I asked for the Bill and lodge complaint in Consumer Forum.",
  },
  {
    id: 14,
    text: "Your best friend did not turn up for your birthday, even though he promised you...",
    response: "Talked to him, asked the reason, and fix a date for his party.",
  },
  {
    id: 15,
    text: "An old man fell outside your house. You will...",
    response:
      "I helped him to stand, if injured gave medical assistance and left him home.",
  },
  {
    id: 16,
    text: "In the marriage party of her close friends she found that the food ran short. She...",
    response:
      "Contacted the nearest restaurant/food caterer and brought ready-made food.",
  },
  {
    id: 17,
    text: "His class teacher was too strict. He...",
    response: "He won her/his heart by sincerity and activeness.",
  },
  {
    id: 18,
    text: "He had a minor scooter accident on his way to the office in which his scooter slightly got damaged. He...",
    response:
      "Gave his scooter in the nearest garage for repair, went to the office and took it after office hour.",
  },
  {
    id: 19,
    text: "Your friend falls into depression after losing his/her job. You...",
    response:
      "Motivated my friend, supported him mentally and financially, and helped him find a new job.",
  },
  {
    id: 20,
    text: "Your parents doesn't support physical relationship with any girl/boy before marriage. You...",
    response:
      "I agreed, devoted myself to my career and made my parents proud.",
  },
  {
    id: 21,
    text: "While marching in the scouts' parade, his left foot got hurt rather badly as he stumbled over a stone. He...",
    response: "He informed Ustaad, went to MI room and took treatment.",
  },
  {
    id: 22,
    text: "While traveling in the metro train, you saw a man acting as blind and getting money from all. You...",
    response:
      "Revealed his truth to passengers and complaint to CISF personnel.",
  },
  {
    id: 23,
    text: "He is too worried about his examinations and therefore he...",
    response: "He stayed calm, studied strategically, and scored well.",
  },
  {
    id: 24,
    text: "When a group of boys of his class wanted to bunk the class, he refused to co-operate with them and they started abusing him. He...",
    response: "He confronted them and complaint to the class teacher.",
  },
  {
    id: 25,
    text: "He was on preparatory leave from his college when his widowed mother got cholera. He...",
    response:
      "He took her to hospital, gave her attention and took proper care and continued his studies as well.",
  },
  {
    id: 26,
    text: "On reaching home on 60 days annual leave he found some girls interested to join the army. He...",
    response:
      "He set up training camp, gave training and motivated other girls to join forces.",
  },
  {
    id: 27,
    text: "Sometimes he feels unhappy, because...",
    response: "He sees poverty as the main barrier to education.",
  },
  {
    id: 28,
    text: "He was a wildlife photographer while clicking a photo of an elephant, it gets angry and attacks him. He...",
    response: "He ran, reached a safe place and waited for it to get normal.",
  },
  {
    id: 29,
    text: "Whenever he feels ignored. He...",
    response: "He enjoys his own company.",
  },
  {
    id: 30,
    text: "He saw the shopkeeper not weighing the things correctly. He...",
    response:
      "He firmly instructed him to weigh properly and would complain if he didn't.",
  },
  {
    id: 31,
    text: "The scholarship which he was getting, stopped. He...",
    response:
      " He informed concerned authority, had hindrances removed, and received a scholarship.",
  },
  {
    id: 32,
    text: "He is a lawyer and his friend wants to divorce her husband. He...",
    response:
      "He inquired, negotiated, suggested couple counseling and, resolved issues amicably.",
  },
  {
    id: 33,
    text: "He stayed at his uncle's after his parents died, now some differences arrived. He...",
    response:
      "He talked to uncle wholeheartedly, removed differences and established a good relationship.",
  },
  {
    id: 34,
    text: "He likes to help destitute, but has no good amount of money. He...",
    response:
      "He coined idea in friends circle, crowed funded, took assistance from authority and helped destitutely.",
  },
  {
    id: 35,
    text: "A drunkard is asking him some address, he has no control on his body. He...",
    response:
      "Called a Rikshaw, made him sit inside and directed the driver to drop hin at his address.",
  },
  {
    id: 36,
    text: "Whenever he goes to meet his friend, his mother assigns him the odd jobs. He...",
    response: "He happily complete the work and met friends.",
  },
  {
    id: 37,
    text: "You are traveling on an auto which collides with a car and the driver of the car starts beating the auto driver. You...",
    response:
      "I intervened, calmed the situation and made amicable settlement b/w them.",
  },
  {
    id: 38,
    text: "If you got chance to become prime minister of India then what three changes you would like to introduce...",
    response:
      "Online tracking of government files and setting up of weekly Lok Adalat and speedy judicial system.",
  },
  {
    id: 39,
    text: "He is going home from duty in the night but a drunkard is troubling him. He...",
    response: "He took it lightly and changed his way and reached home.",
  },
  {
    id: 40,
    text: "His senior asked to accompany him to a friend home for dinner, but he was ignored by them. He...",
    response:
      "He cheerfully talked to them, developed interest and made environment favorable.",
  },
  {
    id: 41,
    text: "Your neighbor’s son has passed out of NDA. He is going for training to IMA. He seeks your advice as to which corps of the Army should he join. You...",
    response:
      "Asked about his interest and suggested him to volunteer for Special Forces.",
  },
  {
    id: 42,
    text: "You like to read books because...",
    response:
      "Because widens the thought process and develop critical thinking about the situation in life.",
  },
  {
    id: 43,
    text: "Amongst all the Indian personalities, dead or alive, who do you admire most and why...",
    response:
      "M.S. Dhoni for his simplicity and trustworthiness as he is down to earth person and had won the confidence of his team.",
  },
  {
    id: 44,
    text: "Life is worth living because...",
    response: "Life gives opportunity to grow and develop.",
  },
  {
    id: 45,
    text: "A friend of yours comes to your room to borrow a book. When he goes away, you find that your wristwatch is missing. You...",
    response:
      "Searched the room properly, asked the mother about it and found it.",
  },
  {
    id: 46,
    text: "Your girlfriend gets in a physical relationship with another boy of your college. You...",
    response: "Broke the relationship with her.",
  },
  {
    id: 47,
    text: "A person is considered a leader when his personality reveals the qualities like...",
    response:
      " Trustworthy, quick decision making, rationality, and cheerful attitude.",
  },
  {
    id: 48,
    text: "To do away with corruption in public life, you would...",
    response:
      "Strengthen the Vigilance and CBI department and setting up of fast track courts and spreading awareness.",
  },
  {
    id: 49,
    text: "While going a journey you would ensure to carry the following items with you...",
    response:
      "Necessary documents, lock and keys and adequate food for the journey.",
  },
  {
    id: 50,
    text: "You think that a neighbor of yours is a foreign spy. You have reported the matter to the police, but they have done nothing about it. You...",
    response:
      "Wrote an application to Superintendent of Police and also gave a copy to the magistrate.",
  },
  {
    id: 51,
    text: "To check the growth of population, what will he suggest...",
    response:
      "Spread awareness, bring population control Bill and give incentive to 2 children.",
  },
  {
    id: 52,
    text: "Your new math teacher is ineffective in teaching. As the monitor of the class, what will you do...",
    response:
      "Gave a collective feedback to her and principal along with the possible solutions.",
  },
  {
    id: 53,
    text: "An orphanage approaches him for help to collect the money for the needy people, he...",
    response:
      "He gathered his friends, convinced them to crowdfund, and got local assistance.",
  },
  {
    id: 54,
    text: "The boss goes for a foreign trip and he will return after 3 months, in this duration what you will do develop the company...",
    response:
      "Implemented pending actions, attracts potential customers, and communicates the company's vision. ",
  },
  {
    id: 55,
    text: "Boys playing cricket near his home, started teasing his mother. He...",
    response: "He warned them, called their parents and made them apologies.",
  },
  {
    id: 56,
    text: "You find your best friend abusing a stranger on the road. You...",
    response:
      "Calmed him, asked the matter, made efforts to remove misunderstanding if any.",
  },
  {
    id: 57,
    text: "He is working in a two-member team, at the time of promotion his colleague got more credits even though he worked well. He...",
    response:
      " He kept the faith, congratulated his teammate, continued performing and later got the promotion.",
  },
  {
    id: 58,
    text: "What if your boyfriend/girlfriend wants to have a physical relationship with you...",
    response: "Asked for some time to think over it and acted accordingly.",
  },
  {
    id: 59,
    text: "You are organizing a football tournament and in that two local teams with a history of rivalry, plans to fight with each other. You...",
    response:
      "Increased security, gave them warning beforehand and ensured that tournament goes smoothly.",
  },
  {
    id: 60,
    text: "You find pornographic videos in your younger brother's mobile. You...",
    response:
      "Talked to him, explained him side effects of pornography and used parental control on his mobile.",
  },
];
